import { Controller } from '@hotwired/stimulus';

// The questions builder. Replaces app_question.coffee for this step; that class still
// serves the employer edit form, which keeps the old markup.
export default class extends Controller {
  static targets = ['input', 'addButton', 'list', 'template', 'counter'];

  static values = { limit: Number };

  connect() {
    this.render();
  }

  add(event) {
    // Enter reaches this too, where the default would submit the whole step.
    event.preventDefault();

    const question = this.inputTarget.value.trim();
    if (question === '' || this.remaining === 0) return;

    this.listTarget.appendChild(this.itemFor(question));
    this.inputTarget.value = '';
    this.render();
  }

  remove(event) {
    event.currentTarget.closest(`[data-${this.identifier}-target="item"]`).remove();
    this.render();
  }

  // The template's own targets, not the kit's internal classes: a chip that renamed an
  // element would break the clone silently.
  itemFor(question) {
    const item = this.templateTarget.content.firstElementChild.cloneNode(true);

    this.inItem(item, 'text').value = question;
    this.inItem(item, 'label').textContent = question;
    this.inItem(item, 'removeButton').setAttribute('aria-label', `Remove ${question}`);

    return item;
  }

  inItem(item, target) {
    return item.querySelector(`[data-${this.identifier}-target="${target}"]`);
  }

  render() {
    const asked = this.listTarget.children.length;
    const left = this.remaining;

    this.counterTarget.textContent = `${left} ${left === 1 ? 'question' : 'questions'} left`;
    this.counterTarget.hidden = asked === 0;
    this.listTarget.hidden = asked === 0;
    this.inputTarget.disabled = left === 0;
    this.addButtonTarget.disabled = left === 0;
  }

  get remaining() {
    return Math.max(this.limitValue - this.listTarget.children.length, 0);
  }
}
